// The strings are the cache keys the risk page has always used; the socket
// listeners invalidate them too, so they must not change.
export enum RiskQueryKeys {
  Matches = "risk-matches",
  Config = "risk-config",
  Scope = "risk-scope",
}
